/* eslint-disable */
import { useEffect } from "react";
import { createContext, useContext, useReducer, useMemo } from "react";
import getExternalDomains from "utils/getExternalDomains";
import { useAuth } from "./auth";
import { useEsriUrls } from "./esriUrlsContext";
// Auth context
const lookupsContext = createContext();
// Setting custom name for the context which is visible on react dev tools
lookupsContext.displayName = "Lookups Context";

// reducer
function reducer(state, action) {
  switch (action.type) {
    case "SET_DATA": {
      return { ...state, ...action.payload };
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

// context provider
function LookupsContextProvider({ children }) {
  const initialState = {
    areasLookup: null,
  };

  const [auth] = useAuth();
  const [esriUrls] = useEsriUrls();

  const [controller, dispatch] = useReducer(reducer, initialState);

  const value = useMemo(() => [controller, dispatch], [controller, dispatch]);

  useEffect(() => {
    // self invoked function
    (async () => {
      try {
        if (auth.token && esriUrls.LKP_AREA) {
          const areasLookupPromise = getExternalDomains({
            neededDomains: [
              { layerId: esriUrls.LKP_AREA, name: "areasLookup" },
            ],
            token: auth.token,
          });
          const lookupsPromises = [areasLookupPromise];
          const [areasLookup] = await Promise.all(lookupsPromises);
          dispatch({
            type: "SET_DATA",
            payload: { areasLookup: areasLookup.areasLookup },
          });
        }
      } catch (error) {
        console.log(error);
      }
    })();
  }, [auth.token, esriUrls.LKP_AREA]);

  return (
    <lookupsContext.Provider value={value}>{children}</lookupsContext.Provider>
  );
}

// custom hook for using context
function useLookups() {
  const context = useContext(lookupsContext);

  if (!context) {
    throw new Error(
      "useLookups should be used inside the LookupsContextProvider."
    );
  }

  return context;
}

export { LookupsContextProvider, useLookups };
